export default __webpack_public_path__ + "static/media/6.368ea0d7.png";